import { environment } from '../environments/environment';
import io from 'socket.io-client';

export const SocketService: any = io(environment.apiOrbiaUrl);